import { createActions, createReducer } from 'reduxsauce';
import { IUser } from 'models/User';

export const { Types, Creators } = createActions({
  setUserData: ['data'],
  setUserCustomerId: ['value', 'madePurchaseIn'],
  setUserOnlyCustomerId: ['selectedCustomerId'],
  setUserNotViewInitialModal: ['value'],
  setViewOptionsDownloadInLot: ['value'],
  setRepresentativeUser: ['representative', 'isBCGUser', 'buBCG']
});

const INITIAL_STATE: IUser = {};

const setUser = (state = INITIAL_STATE, action: any) => ({ ...action.data });

const setCustomerId = (state = INITIAL_STATE, action: any) => ({
  ...state,
  selectedCustomerId: action.value,
  madePurchaseIn: action.madePurchaseIn
});

const setUserOnlyCustomerId = (state = INITIAL_STATE, action: any) => ({
  ...state,
  selectedCustomerId: action.selectedCustomerId
});

const setUserNotViewInitialModal = (state = INITIAL_STATE, action: any) => ({
  ...state,
  notViewInitialModal: action.value,
});

const setRepresentativeUser = (state = INITIAL_STATE, action: any) => ({
  ...state,
  representative: action.representative,
  isBCGUser: action.isBCGUser,
  buBCG: action.buBCG
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_USER_DATA as any]: setUser,
  [Types.SET_USER_CUSTOMER_ID as any]: setCustomerId,
  [Types.SET_USER_ONLY_CUSTOMER_ID as any]: setUserOnlyCustomerId,
  [Types.SET_USER_NOT_VIEW_INITIAL_MODAL as any]: setUserNotViewInitialModal,
  [Types.SET_REPRESENTATIVE_USER as any]: setRepresentativeUser,
});
